(function($){
  'use strict';

    if(!$.gnv){
        $.gnv = new Object();
    };

    $.gnv.enableStopBaloon =  function (){
        $('[data-stop-baloon]').gnv_stopBaloon();
    };

    $.gnv.reloadStopBaloon =  function (){
        $('[data-stop-baloon]').gnv_stopBaloon();
    };

    $.gnv.stopBaloon = function(el, options){
        var base = this;

        base.$el = $(el);
        base.el = el;

        base.$el.data("gnv.stopBaloon", base);

        base.init = function(){
            base.options = $.extend({},$.gnv.stopBaloon.defaultOptions, options);

            base.isVisible = false;

            base.$el.find('[data-stop-baloon-anchor]').on("click touchend", function (e){
                e.preventDefault();
                e.stopPropagation();

                var $flightDirection = $(this).closest('[data-stop-baloon]'),
                    $stopDetail = $flightDirection.find('[data-stop-baloon-detail]');

                if( $stopDetail.hasClass("is-visible"))
                  $stopDetail.removeClass("is-visible");
                else if( $(window).width() < 769 ){
                  $stopDetail.addClass("is-visible");
                } else {
                  $('[data-stop-baloon-detail]').removeClass("is-visible");
                  $stopDetail.addClass("is-visible");
                }

                if( $stopDetail.hasClass("is-visible") && $(window).width() < 769 ){
                    base.isVisible = true;
                    $('html, body').animate({
                        scrollTop: $flightDirection.offset().top
                    }, 500);
                } else {
                    base.isVisible = false;
                }

            });

            base.$el.find('[data-stop-baloon-detail]').on("click touchend", function (e) {
                e.stopPropagation();
            });

            $(document).on("click touchend", function () {
              if($(window).width() > 768)
                base.$el.find('[data-stop-baloon-detail]').removeClass("is-visible");
            });

        };
        base.init();
    };

    $.gnv.stopBaloon.defaultOptions = {
    };

    $.fn.gnv_stopBaloon = function(options){
        return this.each(function(){
            (new $.gnv.stopBaloon(this, options));
        });
    };

})(jQuery);
